const EdugramIconNew = dynamic(
  () =>
    import('@public/static/icons/edugramIcon').then(
      (mod) => mod.EdugramIconNew
    ),
  { ssr: false }
)
import Link from 'next/link'
import { Tooltip } from '@nextui-org/react-latest'
import DollarIcon from '@public/static/icons/footer/dollarIcon'
import CookiesIcon from '@public/static/icons/footer/cookiesIcon'
import WorldIcon from '@public/static/icons/footer/worldIcon'
import { useTranslation } from 'react-i18next'
import styled from '@emotion/styled'
import dynamic from 'next/dynamic'
import { supportedLanguages } from '@components/pages/home/LandingPage/Sections/Header'
import { fontFamilies } from '@configs/styles/config'
const SocialLinks = dynamic(() => import('./components/SocialLinks'), {
  loading: () => <div className="w-full h-[40px]" />,
})

const languages = supportedLanguages

export const FooterWrapper = styled.div`
  width: 100%;
  max-width: 1500px;
  display: flex;
  justify-content: space-between;
  margin: auto;
  margin-top: ${(props) => (props.removeTopMargin ? '0px' : '103px')};
  padding: ${(props) =>
    props.isCreateCourse
      ? '30px 0px'
      : props.removeTopMargin
        ? '30px 0px 0px 0px'
        : '30px 0px'};

  @media (max-width: 640px) {
    padding: ${(props) => (props.isCreateCourse ? '30px 0' : '30px 16px')};
  }
  @media (max-width: 1024px) {
    flex-direction: column;
    margin-top: 30px;
  }
`

export const FooterHeading = styled.div`
  font-size: 30px;
  font-family: ${fontFamilies.bold};
  font-weight: bold;
  color: #2d3353;
  margin-bottom: 10px;
  @media (max-width: 1561px) {
    font-size: 1.9vw;
  }
  @media (max-width: 1020px) {
    font-size: 20px;
  }
`

export const FooterInfoBlock = styled.div`
  max-width: max-content;
  margin-bottom: 30px;
  /* background-color: red; */
  min-width: max-content;
  /* flex: 1; */
  @media (max-width: 1024px) {
    flex: 1;
    max-width: none;
  }
`

export const FooterText = styled.div`
  font-size: 20px;
  color: #54586c;
  margin-top: 15px;
  cursor: pointer;
  @media (max-width: 1561px) {
    font-size: 1.2vw;
  }
  @media (max-width: 1290px) {
    font-size: 16px;
  }
`

export const FooterInfoWrapper = styled.div`
  display: flex;
  gap: 10%;
  flex: 1;
  @media (min-width: 1650px) {
    justify-content: flex-end;
  }
  justify-content: ${(props) =>
    props.isCreateCourse ? 'flex-start' : 'flex-end'};
  margin-left: 60px;

  flex-wrap: wrap;
  margin-right: 0;
  @media (max-width: 1024px) {
    margin: 0;
    justify-content: flex-start;
    /* justify-content: space-between; */
    margin-top: 30px;
  }
`

const Footer = ({
  isCreateCourse = false,
  removeTopMargin = false,
  removeBottomXPadding = false,
}) => {
  const { i18n, t } = useTranslation('footer')
  const lang = languages.find((lng) => lng.code === i18n.language)

  return (
    <>
      <FooterWrapper
        isCreateCourse={isCreateCourse}
        removeTopMargin={removeTopMargin}
      >
        <div>
          <div>
            <EdugramIconNew />
          </div>
          <FooterHeading style={{ marginTop: 30 }}>
            {t('newFooter.socialNetwork')}
          </FooterHeading>
          <SocialLinks />
        </div>

        <FooterInfoWrapper isCreateCourse={isCreateCourse}>
          <FooterInfoBlock isCreateCourse={isCreateCourse}>
            <FooterHeading>{t('newFooter.aboutUs')}</FooterHeading>
            <Link href={'/author/become-author/'}>
              <FooterText className="font-regular">
                {t('newFooter.becomeAuthor')}
              </FooterText>
            </Link>
            <Link href={'/our-advantageous/'}>
              <FooterText className="font-regular">
                {t('newFooter.ourAdvantageous')}
              </FooterText>
            </Link>
            <Tooltip content={t('newFooter.comingSoon')} placement="top-start">
              <FooterText className="font-regular">
                {t('newFooter.ourGoal')}
              </FooterText>
            </Tooltip>
            <Tooltip content={t('newFooter.comingSoon')} placement="top-start">
              <FooterText className="font-regular">
                {t('newFooter.support')}
              </FooterText>
            </Tooltip>
          </FooterInfoBlock>
          <FooterInfoBlock isCreateCourse={isCreateCourse}>
            <FooterHeading>{t('newFooter.possibilities')}</FooterHeading>
            <Tooltip content={t('newFooter.comingSoon')} placement="top-start">
              <FooterText className="font-regular">
                {t('newFooter.premium')}
              </FooterText>
            </Tooltip>
            <Tooltip content={t('newFooter.comingSoon')} placement="top-start">
              <FooterText className="font-regular">
                {t('newFooter.jobs')}
              </FooterText>
            </Tooltip>
            <Tooltip content={t('newFooter.comingSoon')} placement="top-start">
              <FooterText className="font-regular">
                {t('newFooter.parents')}
              </FooterText>
            </Tooltip>
            <Tooltip content={t('newFooter.comingSoon')} placement="top-start">
              <FooterText className="font-regular">
                {t('newFooter.business')}
              </FooterText>
            </Tooltip>
          </FooterInfoBlock>
          <FooterInfoBlock isCreateCourse={isCreateCourse}>
            <FooterHeading>{t('newFooter.cooperation')}</FooterHeading>
            <Link href={'/author/become-author/'}>
              <FooterText className="font-regular">
                {t('newFooter.becomeAuthor')}
              </FooterText>
            </Link>
            <Link href={'/pricing/'}>
              <FooterText className="font-regular">
                {t('newFooter.pricing')}
              </FooterText>
            </Link>
            <Link href={'/referrals/'}>
              <FooterText className="font-regular">
                {t('newFooter.referrals')}
              </FooterText>
            </Link>
          </FooterInfoBlock>
          <FooterInfoBlock isCreateCourse={isCreateCourse}>
            <FooterHeading>{t('newFooter.support')}</FooterHeading>
            <Tooltip content={t('newFooter.comingSoon')} placement="top-start">
              <FooterText className="font-regular">
                {t('newFooter.howItWorks')}
              </FooterText>
            </Tooltip>
            <Link href={'/help-centre/student'}>
              <FooterText className="font-regular">
                {t('newFooter.helpCentre')}
              </FooterText>
            </Link>
            <Link href={'/contact-us'}>
              <FooterText className="font-regular">
                {t('newFooter.contactUs')}
              </FooterText>
            </Link>
          </FooterInfoBlock>
        </FooterInfoWrapper>
      </FooterWrapper>
      <div className="h-[1px] w-full max-w-[1500px] mx-auto bg-uguGray" />
      <div
        className={`py-2.5 flex justify-between gap-3 sm:px-0 ${
          removeBottomXPadding ? 'px-0' : 'px-3.5'
        } flex-wrap items-center w-full max-w-[1500px] mx-auto`}
      >
        <div className="flex items-center gap-1.5 flex-wrap">
          <span className="text-base font-regular text-uguPurple">
            © {new Date().getFullYear()} Edugram Inc.
          </span>
          <span className="text-base font-bold text-uguPurple">·</span>
          <Link href={'/help-centre/legal/privacy-policy/'}>
            <span className="text-base font-regular text-uguPurple hover:underline decoration-1 cursor-pointer">
              {t('newFooter.privacy')}
            </span>
          </Link>
          <span className="text-base font-bold text-uguPurple">·</span>
          <Link href={'/help-centre/legal/terms-and-conditions/'}>
            <span className="text-base font-regular text-uguPurple hover:underline decoration-1 cursor-pointer">
              {t('newFooter.terms')}
            </span>
          </Link>
          <span className="text-base font-bold text-uguPurple">·</span>
          <span className="text-base font-regular text-uguPurple hover:underline decoration-1 cursor-pointer">
            {t('newFooter.sitemap')}
          </span>
        </div>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <DollarIcon />
            <span className="text-base font-regular text-uguPurple">USD</span>
          </div>
          <div className="flex items-center gap-2">
            <CookiesIcon />
            <span className="text-base font-regular text-uguPurple">
              {t('newFooter.cookies')}
            </span>
          </div>
          <div className="flex items-center gap-2 max-h-2">
            <WorldIcon />
            <span className="text-base font-regular text-uguPurple">
              {lang?.name} ({lang?.code}){' '}
            </span>
          </div>
        </div>
      </div>
      <div className="px-3.5 px-0 hidden" />
    </>
  )
}

export default Footer
